import React from 'react'
import { font } from './constants'
import fieldStyles from './FormField.module.css'

function FormInput({
  label,
  placeholder,
  helpText,
  icon,
  required = true,
  value,
  onChange,
  type = 'text',
  readOnly = false,
  multiline = false,
  rows = 4,
  disabled = false,
  variant = 'light',
}) {
  const isLight = variant === 'light'
  const labelColor = isLight ? '#6b6b6b' : '#b0b8c8'
  const inputColor = readOnly
    ? isLight
      ? '#374151'
      : '#b0b8c8'
    : isLight
      ? '#363636'
      : '#e2e8f0'
  const wrapBg = readOnly && isLight ? 'rgba(0,0,0,0.055)' : isLight ? 'rgba(0,0,0,0.04)' : 'rgba(255,255,255,0.04)'
  const wrapBorder = isLight ? '1px solid rgba(0,0,0,0.1)' : '1px solid rgba(255,255,255,0.08)'
  const wrapBorderFinal = readOnly && isLight ? '1px solid rgba(0,0,0,0.12)' : wrapBorder

  const fieldStyle = {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    color: inputColor,
    fontSize: 14,
    width: '100%',
    fontFamily: font,
    cursor: disabled ? 'not-allowed' : readOnly ? 'default' : 'text',
    resize: multiline ? 'vertical' : undefined,
    minHeight: multiline ? rows * 22 : undefined,
    lineHeight: multiline ? 1.45 : undefined,
  }
  return (
    <div style={{ marginBottom: 20, cursor: disabled ? 'not-allowed' : undefined }}>
      <label style={{ display: 'block', fontSize: isLight ? 13 : 14, color: labelColor, marginBottom: isLight ? 5 : 6, fontFamily: font }}>
        {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
      </label>
      <div
        className={isLight ? fieldStyles.wrapLight : undefined}
        style={{
          display: 'flex',
          alignItems: multiline ? 'flex-start' : 'center',
          background: wrapBg,
          border: wrapBorderFinal,
          borderRadius: 8,
          padding: '10px 14px',
          cursor: disabled ? 'not-allowed' : undefined,
          opacity: disabled ? 0.85 : 1,
        }}
      >
        {icon && (
          <span
            style={{
              marginRight: 10,
              fontSize: 16,
              opacity: isLight ? 0.55 : 0.6,
              marginTop: multiline ? 2 : 0,
              color: isLight ? '#363636' : undefined,
            }}
          >
            {icon}
          </span>
        )}
        {multiline ? (
          <textarea
            required={required && !readOnly}
            readOnly={readOnly}
            rows={rows}
            placeholder={placeholder}
            value={value || ''}
            onChange={e => !readOnly && onChange?.(e.target.value)}
            style={fieldStyle}
            disabled={disabled}
          />
        ) : (
          <input
            required={required && !readOnly}
            readOnly={readOnly}
            type={type}
            placeholder={placeholder}
            value={value || ''}
            onChange={e => !readOnly && onChange?.(e.target.value)}
            style={fieldStyle}
            disabled={disabled}
          />
        )}
      </div>
      {helpText && (
        <p style={{ fontSize: 12, color: isLight ? '#999999' : '#6b7a90', marginTop: 4, fontFamily: font, lineHeight: 1.4 }}>{helpText}</p>
      )}
    </div>
  )
}

export default FormInput
